import { useMutation } from "react-query";
import { axiosInstance } from "../../config/axios";

export interface IBulkChangeRequestApprove {
  ids: (string | number)[];
  approve: boolean;
  description: string;
  operationCode: string;
  operationMode: string;
}

async function bulkApproveChangeRequest(data: IBulkChangeRequestApprove): Promise<any> {
  return (await axiosInstance.post("/ChangeRequest/BulkApprove", data)).data;
}

export function useBulkApproveChangeRequest() {
  return useMutation<any, Error, IBulkChangeRequestApprove>((variables) =>
    bulkApproveChangeRequest(variables)
  );
}